import React,{useEffect} from "react";
// importing aos
import AOS from 'aos';
import 'aos/dist/aos.css';

function Contacts () {
  useEffect(() => {
    AOS.init();
  }, [])

    return (
        <main className="section">
        <div className="container" data-aos="zoom-in" data-aos-duration="500">
          <h1 className="title-1">Contacts</h1>
  
          <ul className="content-list">
            <li className="content-list__item">
              <h2 className="title-2">Location</h2>
              <p>Moscow, Russia</p>
            </li>
            <li className="content-list__item">
              <h2 className="title-2">Telegram / WhatsApp</h2>
              <p>
                <a href="tel:+79051234567">+7 (928) 017-30-40</a>
              </p>
            </li>
            <li className="content-list__item">
              <h2 className="title-2">Email</h2>
              <p>
                <a href="mailto:webdev@protonmail.com">israilh5@gmail.com</a>
              </p>
            </li>
          </ul>
        </div>
      </main>
    )
}


export default Contacts;